module.exports = __webpack_public_path__ + "static/media/Architecture Fence.a35e4fe8.svg";